import React from "react";
import { AlertTriangle, HardHat } from "lucide-react";
import { useLang } from "../../i18n";
import { standards } from "../../data/safety";

export default function StandardsGuide() {
  const { t, lang } = useLang();
  return (
    <div>
      <p className="text-sm text-wachs-dim leading-relaxed max-w-2xl">{t.safety.standards.intro}</p>

      {/* Replace after impact callout */}
      <div className="mt-6 rounded-lg border border-sonne/40 bg-sonne/10 p-5 flex items-start gap-3" data-testid="standards-replace-callout">
        <AlertTriangle className="text-sonne shrink-0 mt-0.5" size={20} />
        <div>
          <p className="font-mono text-sm text-sonne uppercase tracking-wide">{t.safety.standards.replaceTitle}</p>
          <p className="mt-1 text-sm text-wachs-dim leading-relaxed">{t.safety.standards.replaceMsg}</p>
        </div>
      </div>

      {/* Standards table */}
      <div className="mt-6 grid-panel rounded-lg overflow-hidden">
        <div className="hidden md:grid grid-cols-[1fr_1.4fr_1.2fr] gap-4 px-5 py-3 border-b border-bronze/20 bg-tiefsee-2/40 instrument-label text-wachs-dim">
          <span>{t.safety.standards.col.item}</span>
          <span>{t.safety.standards.col.standard}</span>
          <span>{t.safety.standards.col.note}</span>
        </div>
        <div className="divide-y divide-bronze/10">
          {standards.map((s) => (
            <div key={s.id} data-testid={`standard-row-${s.id}`} className="grid md:grid-cols-[1fr_1.4fr_1.2fr] gap-2 md:gap-4 px-5 py-4">
              <div className="flex items-center gap-2 text-wachs">
                <HardHat size={16} className="text-sonne shrink-0 md:hidden" />
                <span className="font-medium text-sm">{lang === "de" ? s.de : s.en}</span>
              </div>
              <div className="font-mono text-xs text-bronze-soft leading-relaxed">{lang === "de" ? s.standardDe : s.standardEn}</div>
              <div className="text-xs text-wachs-dim leading-relaxed">{lang === "de" ? s.noteDe : s.noteEn}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
